module.exports = __webpack_public_path__ + "img/days.b926517e.svg";